// A script chunk that fails to load almost always means a deploy happened while the
// visitor had the page open: the new deployment no longer has the old build's files.
// reloadOnce() reloads the page (the fresh HTML points at the new files), at most once
// a minute so a chunk that is really broken can't cause a reload loop.

const RELOADED_AT = "chunkReloadAt";

export const isChunkError = (error) =>
  error?.name === "ChunkLoadError" || /Loading (CSS )?chunk [\w-]+ failed/i.test(error?.message || "");

/** Reload for a chunk load error; returns false (and does nothing) if it isn't one or a reload just happened. */
export function reloadOnce(error) {
  if (!isChunkError(error)) return false;
  try {
    if (Date.now() - Number(sessionStorage.getItem(RELOADED_AT) || 0) < 60000) return false;
    sessionStorage.setItem(RELOADED_AT, String(Date.now()));
  } catch {
    return false; // no storage: can't tell, so don't risk a loop
  }
  window.location.reload();
  return true;
}
